'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _reactResponsive = require('react-responsive');

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _reactPhotoGallery = require('react-photo-gallery');

var _reactPhotoGallery2 = _interopRequireDefault(_reactPhotoGallery);

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Image
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
var image = (0, _glamor.css)({
  display: 'block',
  float: 'left',
  // cursor: 'pointer',
  border: 0
});

// ----------------------------------- Components
// eslint-disable-line import/no-extraneous-dependencies

var imageClass = image.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/* eslint-disable prefer-template */
/** Images */
var Images = function Images(props) {
  /** ImageX */
  var ImageX = function ImageX(_ref) {
    var index = _ref.index,
        onClick = _ref.onClick,
        photo = _ref.photo,
        margin = _ref.margin;
    return _react2.default.createElement(_Image2.default, {
      src: photo.src,
      className: imageClass,
      style: { width: photo.width, height: photo.height, margin: margin },
      rawWidth: photo.width,
      rawHeight: photo.height,
      loader: props.loader,
      gradientPreset: props.gradientPreset,
      key: photo.src + '#' + index
      // onClick={e => onClick(e, { index, photo })}
    });
  };

  return _react2.default.createElement(
    _reactResponsive2.default,
    { query: '(min-width: 768px)', values: { deviceWidth: 1440, deviceHeight: 900, type: 'screen' } },
    function (matches) {
      return _react2.default.createElement(_reactPhotoGallery2.default, {
        photos: props.photos
        // onClick={this.showModal}
        , columns: matches === true ? props.columns : 1,
        ImageComponent: ImageX
      });
    }
  );
};
/* eslint-enable prefer-template */

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------------Typing
// ------------------------------------------------------------------------------
Images.propTypes = process.env.NODE_ENV !== "production" ? {
  photos: _propTypes2.default.array, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  columns: _propTypes2.default.number,
  classes: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  loader: _propTypes2.default.string,
  gradientPreset: _propTypes2.default.string
} : {};

Images.defaultProps = {
  columns: 3,
  loader: 'spinner',
  gradientPreset: 'gray'
};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = Images;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/components/lib/Images.js
// module id = 431
// module chunks = 168707334958949